export default "__VITE_ASSET__W4eNGuU3__";